import { COLOURS } from "../variables"
export default function UnableToRetrieveData(){
    return(
        <div className="text-document">
          <p style={{color: COLOURS.fontColor}}>unable to retrieve data...</p>
        </div>
    )
}